module.exports = __webpack_public_path__ + "static/media/Manuel_3_Application_15_160.aa0a1ea0.pdf";